import { apiService } from './api.service'

export interface DocumentWorkflowSupportedAction {
  id: number
  slug: string
  default_label: string
  position: number
}

interface ApiResponse {
  count: number
  results: DocumentWorkflowSupportedAction[]
  next: string | null
  previous: string | null
}

class DocumentWorkflowSupportedActionService {
  private _listAllCache: Promise<DocumentWorkflowSupportedAction[]> | null = null

  async listAll(): Promise<DocumentWorkflowSupportedAction[]> {
    if (!this._listAllCache) {
      this._listAllCache = apiService
        .get<ApiResponse>('document_workflow_supported_actions/', {
          params: { page_size: 500 },
        })
        .then((res) => res.data.results ?? [])
    }
    return this._listAllCache
  }

  clearCache(): void {
    this._listAllCache = null
  }
}

export const documentWorkflowSupportedActionService = new DocumentWorkflowSupportedActionService()
